import * as Sentry from "@sentry/react";
import { hasAnalyticsConsent, onConsentChange } from "./analytics/consent";

const SENTRY_DSN = "https://296672d9cde7641571e9428a18e6cb96@o4512118637264896.ingest.de.sentry.io/4512118647095376";

let enabled = false;

function enableSentry(): void {
    if (enabled) return;

    Sentry.init({
        dsn: SENTRY_DSN,
        // Do not attach IP address, cookies, or authenticated-user information
        // automatically. Replay also masks page text and every input below.
        sendDefaultPii: false,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                maskAllInputs: true,
                networkCaptureBodies: false,
            }),
        ],
        tracesSampleRate: 1.0,
        // Keep trace headers on this app only. Cross-origin APIs are excluded
        // until their CORS configuration explicitly permits Sentry headers.
        tracePropagationTargets: ["localhost", /^https:\/\/nihongotech\.teqseq\.com(?:\/|$)/],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });

    enabled = true;
}

function applyConsent(granted: boolean): void {
    if (granted) {
        enableSentry();
        return;
    }

    if (!enabled) return;
    enabled = false;
    void Sentry.close(2000);
}

// Sentry is an optional measurement provider: it starts only after the
// Iubenda measurement-consent signal and is disabled if that consent changes.
export function initSentry(): void {
    applyConsent(hasAnalyticsConsent());
    onConsentChange(applyConsent);
}
